import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Logbooks from "./pages/Logbooks";
import HematologyLogs from "./pages/HematologyLogs";
import Layout from "./layout/Layout";
import ReagentInventoryLogs from "./pages/ReagentInventoryLogs";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/logbooks"
          element={
            <Layout>
              <Logbooks />
            </Layout>
          }
        />
        <Route
          path="/hematology-logs"
          element={
            <Layout>
              <HematologyLogs />
            </Layout>
          }
        />
        <Route
          path="/reagent-inventory-logs"
          element={
            <Layout>
              <ReagentInventoryLogs />
            </Layout>
          }
        />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </Router>
  );
}

export default App;